/*
 * @Descripttion: 自定义监控监控
 * @version: 1.2.3
 * @Author: Ray
 * @Date: 2024-01-29 13:24:20
 * @LastEditors: 董元
 * @LastEditTime: 2024-08-08 10:42:21
 */
import { log } from "./manageLog.js"
let responseHistory = [], MAX_HISTORY_LENGTH = 3;

function responseHistoryReport({ res, requestData, msgCode = "100", whiteList = [], blackList = [], apikey = "" }) {
    const url = res.responseURL
    const params = res.mito_xhr.method === "get" || res.mito_xhr.method === "GET" ? "" : requestData

    // 只监听白名单 包含返回true  不包含返回false
    if (whiteList.length > 0 && !whiteList.some(item => (url).includes(item))) {
        return;
    }
    // 不监听黑名单 包含返回true  不包含返回false
    if (blackList.length > 0 && blackList.some(item => (url).includes(item))) {
        return;
    }
    // 接口正常调用，状态码为200
    if (res.status === 200) {
        let responseData = {}
        try{
            responseData = JSON.parse(res.responseText)
        }catch(e){
        }
        if (responseData.msgCode !== undefined || responseData.code !== undefined) {
            // 处理数据
            const reportData = {
                params: params,
                url: url,
                data: responseData,
                method: res.method
            }   
            // 将请求信息添加到队列 兼容老接口code === 0 msgCode == "100" msgCode == 100
            responseHistory.push(responseData.msgCode == msgCode || responseData.code === 0 ? { success: reportData } : { error: reportData });
            // 获取队列中的最后一条数据，判断是否为error error则上传整个队列
            if (responseHistory[responseHistory.length - 1].error) {
                log({
                    message: responseHistory,
                    tag: apikey,
                    type: "LOG_ERROR"
                })
            }
            // 如果队列长度超过MAX_HISTORY_LENGTH，移除最早的请求
            if (responseHistory.length === MAX_HISTORY_LENGTH) {
                responseHistory.shift();
            }
        }
    }
}

export default responseHistoryReport;